import { z } from "zod";
export const CreateUserParamsSchema = z.object({
    email: z.string().email(),
    password: z.string().optional(),
    displayName: z.string().optional(),
    role: z.string().optional(),
    language: z.enum(["en", "de", "uk", "ru"]).optional(),
    curator_uid: z.string().optional(),
    course_ids: z.array(z.number()).optional(),
});
export const UserRecordSchema = z.object({
    uid: z.string(),
    email: z.string().email().optional(),
    displayName: z.string().optional(),
});
